import { LinkListItem as CommonLinkListItem, type LinkListItemProps } from '@monorepo/common';

function LinkListItem({ iconSrc, text, showBadge, onClick, id }: LinkListItemProps) {
  return <CommonLinkListItem iconSrc={iconSrc} text={text} showBadge={showBadge} onClick={onClick} id={id} />;
}

export default LinkListItem;
